module.exports = __webpack_public_path__ + "as.no1.d55d93f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/as.no1.jpg
// module id = AVxF
// module chunks = 0